import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './Proof.module.css';
import { db } from '../../../firebase-config';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';



function Proof() {
    const [proofs, setProofs] = useState([]);
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        fetchProofs();
    }, []);

    const fetchProofs = async () => {
        try {
            setLoading(true);
            const q = query(collection(db, 'proofs'), orderBy('order', 'asc'));
            const querySnapshot = await getDocs(q);
            const firebaseProofs = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            
            console.log('Firebase proofs:', firebaseProofs);
            setProofs(firebaseProofs);
            
            console.log(`Total proofs: ${firebaseProofs.length} from CMS`);
        } catch (error) {
            console.error('Error fetching proofs:', error);
            // Set empty array if Firebase fails
            setProofs([]);
        } finally {
            setLoading(false);
        }
    };

    const CustomPrevArrow = (props) => {
        const { onClick } = props;
        return <div className={`${styles.customArrow} ${styles.prev}`} onClick={onClick} />;
    };

    const CustomNextArrow = (props) => {
        const { onClick } = props;
        return <div className={`${styles.customArrow} ${styles.next}`} onClick={onClick} />;
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true, // Enables automatic sliding
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true, // Ensure arrows are enabled
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    if (loading) {
        return (
            <div className={styles.proofContainer}>
                <p className={styles.proofParagraph}>
                    Not enough? Do you want more? Come with me. I have something for you and that will definitely give you satisfaction!
                </p>
                <div className={styles.proofItems}>
                    <div style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
                        Loading proofs...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.proofContainer}>
            <p className={styles.proofParagraph}>
                Not enough? Do you want more? Come with me. I have something for you and that will definitely give you satisfaction!
            </p>

            <div className={styles.proofItems}>
                {proofs.length > 0 ? (
                    <Slider {...settings}>
                        {proofs.map((item, i) => (
                            <div key={item.id || i}>
                                <img
                                    className={styles.proofImg}
                                    src={item.imageUrl}
                                    alt={item.title || item.alt || "Payment Proof"}
                                />
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <div style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
                        No proofs available
                    </div>
                )}
            </div>

        </div>
    );
}

export default Proof;
